import { render, staticRenderFns } from "./signinComponent.vue?vue&type=template&id=f1b990cc&scoped=true"
import script from "./signinComponent.vue?vue&type=script&lang=js"
export * from "./signinComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b990cc",
  null
  
)

export default component.exports